import { SideModal } from '@tymbe/ty-components/modals';
import { useState, createContext } from 'react';
import { ApplicationDetail } from '../../../../components/ApplicationDetail/ApplicationDetail';
import { ApplicationData } from '@tymbe/schema/application.interface';
import { TyTimeline } from './TyTimeline';

export const ModalContext = createContext<{
  toggleAttendanceDetail: (id: ApplicationData | null) => void;
}>({
  toggleAttendanceDetail: () => null,
});

const UserLives = () => {
  const [attendanceDetailData, setAttendanceDetailData] =
    useState<ApplicationData | null>(null);

  const toggleAttendanceDetail = (id: ApplicationData | null) =>
    setAttendanceDetailData(id);

  return (
    <ModalContext.Provider
      value={{
        toggleAttendanceDetail: toggleAttendanceDetail,
      }}
    >
      <div className="py-3 px-10">
        <TyTimeline />
        <SideModal
          title="Detail směny"
          className="w-[520px]"
          isOpen={!!attendanceDetailData}
          onRequestClose={() => {
            setAttendanceDetailData(null);
          }}
        >
          {!!attendanceDetailData && (
            <ApplicationDetail
              applicationId={attendanceDetailData.id.toString()}
              activeExcuseId={attendanceDetailData.lastExcuse?.id.toString()}
            />
          )}
        </SideModal>
      </div>
    </ModalContext.Provider>
  );
};

export default UserLives;
